<template>
  <div :id="anchor" class="section-header">
    <div class="section-header__left">
      <span class="section-header__badge">
        <span class="material-icons-outlined">{{ icon }}</span>
      </span>
      <span class="section-header__title">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',

  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    anchor: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid #E4DFDA;
}

.section-header__left {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.section-header__badge {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  background: #212121;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.section-header__badge .material-icons-outlined {
  font-size: 14px;
  line-height: 1;
}

.section-header__title {
  font-family: 'Baloo 2', 'DM Sans', sans-serif;
  font-size: 19px;
  font-weight: 700;
  color: #212121;
  line-height: 1.1;
}
</style>
